import 'vue3-rich-accordion/accordion-library-styles.scss';
import '../../style/templates/collection.scss';
import { CommercialCollection } from '../layout/mountCollection';

document.addEventListener('DOMContentLoaded', () => {
  window.scrollTo(0, 0);
  new CommercialCollection();
});
